var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "chat",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.242,
    height: 90.369,
    viewBox: "0 0 150.242 90.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_27",
    x: 71.769,
    y: 11.896,
    width: 78.473,
    height: 78.473,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_159",
    "data-name": "Groupe 159",
    transform: "translate(-3062.114 135.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_158",
    "data-name": "Groupe 158",
    transform: "translate(2446.67 -258.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_88",
    "data-name": "Groupe 88",
    transform: "translate(695.273 139.203)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_298",
    "data-name": "Trac\\xE9 298",
    d: "M794.159,114.355a31.173,31.173,0,1,0-48.566,25.874l.021.138a10.67,10.67,0,0,0,3.535,2.251l.041-.138c1.473,1.252,7.6,3.255,14.668,3.24h.153a28.658,28.658,0,0,0,13.6-3.1s.038-.082.1-.236a11.107,11.107,0,0,0,2.946-2.012q.027-.18.05-.354A31.138,31.138,0,0,0,794.159,114.355Z",
    transform: "translate(-731.809 -83.182)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 615.44, 122.25)",
    filter: "url(#Ellipse_27)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27-2",
    "data-name": "Ellipse 27",
    cx: 30.237,
    cy: 30.237,
    rx: 30.237,
    ry: 30.237,
    transform: "translate(80.77 17.9)",
    fill: "var(--third-color)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_297",
    "data-name": "Trac\\xE9 297",
    d: "M784.966,231.22s-7.206.589-5.3,13.716a10.348,10.348,0,0,0,3.429,2.183l4.054-13.716Z",
    transform: "translate(-70.067 -48.407)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_298-2",
    "data-name": "Trac\\xE9 298",
    d: "M872.57,231.22s7.206.589,5.3,13.716a10.348,10.348,0,0,1-3.429,2.183L870.39,233.4Z",
    transform: "translate(-134.292 -48.407)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_299",
    "data-name": "Trac\\xE9 299",
    d: "M786.793,158.2s-3.429,9.975-5.3,9.041c0,0,18.047,15.587,33.978,0a47.489,47.489,0,0,0-6.858-9.041Z",
    transform: "translate(-71.581 3.102)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 13.404,
    cy: 13.404,
    rx: 13.404,
    ry: 13.404,
    transform: "translate(713.373 146.964)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_300",
    "data-name": "Trac\\xE9 300",
    d: "M814.945,231.22H791.578l-2.195,9.362s-1.281,4.33.312,6.233,16.5,6.234,27.432.312a12.2,12.2,0,0,0,.312-7.792c-1.246-4.363-.312-.312-.312-.312Z",
    transform: "translate(-76.806 -48.407)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_301",
    "data-name": "Trac\\xE9 301",
    d: "M816,231.22H792.62l-2.177,9.362s-1.281,4.33.312,6.233,16.5,6.234,27.432.312a12.2,12.2,0,0,0,.312-7.792c-1.246-4.363-.312-.312-.312-.312Z",
    transform: "translate(-77.554 -48.407)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_302",
    "data-name": "Trac\\xE9 302",
    d: "M815.4,231.22H792.022l-2.189,9.362s-1.281,4.33.312,6.233,16.5,6.234,27.432.312a12.2,12.2,0,0,0,.312-7.792c-1.246-4.363-.312-.312-.312-.312Z",
    transform: "translate(-77.123 -48.407)",
    fill: "var(--main-color)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_303",
    "data-name": "Trac\\xE9 303",
    d: "M659.82,121.7h9.353v7.659a4.507,4.507,0,0,1-4.507,4.507h-.339a4.507,4.507,0,0,1-4.507-4.507Z",
    transform: "translate(62.246 53.357)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_304",
    "data-name": "Trac\\xE9 304",
    d: "M659.82,120.52h9.353v7.659a4.507,4.507,0,0,1-4.507,4.507h-.339a4.507,4.507,0,0,1-4.507-4.507V120.52Z",
    transform: "translate(62.246 54.189)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_305",
    "data-name": "Trac\\xE9 305",
    d: "M822.83,205.592a13.459,13.459,0,0,0,9.353.027V204.47H822.83Z",
    transform: "translate(-100.743 -29.537)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 13.404,
    cy: 13.404,
    rx: 13.404,
    ry: 13.404,
    transform: "translate(713.373 149.875)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_306",
    "data-name": "Trac\\xE9 306",
    d: "M795.25,124.412h25.556s-2.183-10.311-11.845-9.663S795.25,124.412,795.25,124.412Z",
    transform: "translate(-81.288 33.773)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.246,
    cy: 2.339,
    rx: 1.246,
    ry: 2.339,
    transform: "translate(712.404 160.368)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.246,
    cy: 2.339,
    rx: 1.246,
    ry: 2.339,
    transform: "translate(738.59 160.368)",
    fill: "#fda57d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_307",
    "data-name": "Trac\\xE9 307",
    d: "M795.25,125.592h25.556s-2.183-10.311-11.845-9.663S795.25,125.592,795.25,125.592Z",
    transform: "translate(-81.288 32.941)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_646",
    "data-name": "Trac\\xE9 646",
    d: "M237.933,222.239a1.091,1.091,0,0,1-.826-.388l-12.4-14.333a1.466,1.466,0,0,0-1.106-.516H158.1a3.871,3.871,0,0,1-3.749-3.974V177.99a3.871,3.871,0,0,1,3.749-3.974h84.865a3.871,3.871,0,0,1,3.749,3.974v25.038A3.871,3.871,0,0,1,242.966,207H240.56a1.549,1.549,0,0,0-1.5,1.59v12.453a1.185,1.185,0,0,1-.717,1.111A1.075,1.075,0,0,1,237.933,222.239Z",
    transform: "translate(2907.761 -309.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(3070 -127)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(3095 -127)",
    fill: "var(--second-color)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(3120 -127)",
    fill: "var(--second-color)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.20a1f80d.svg";
export { ForwardRef as ReactComponent };